import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { FormControl, Validators } from '@angular/forms';
import { CalculadoraService } from '../../services/calculadora.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  regiones : Region[] = [];
  comunas : Comuna[]=[];
  distribuidoras : Distribuidora[] = [];
  distribuidoraObj : Distribuidora;
  regionId : number=-1;
  beneficiada : boolean = true;
  compra : boolean = true;
  showElec : boolean = false;
  showEquipo : boolean = false;
  showPreguntas : boolean = false;
  showAltitud : boolean = false;
  showDist : boolean = false;
  showDistPage : boolean = false;
  showFinanciamiento: boolean = false;
  showEmpaquetadas: boolean = false;
  showProgramas : boolean = false;
  selDistribuidora : string = "sel";
  selFinanciamiento : number = -1;
  potencias = [9000,12000,18000,22000,24000];

  casa : string ="assets/images/CasaON.png";
  casaOff : string ="assets/images/CasaOFF.png";
  casaOn : string ="assets/images/CasaON.png";
  txcasa : string ="text-prim pl-3";
  txcasas : string ="pl-3";
  txedificio : string ="pl-3";
  txtabiqueria : string ="text-prim pl-3";
  txladrillo : string ="pl-3";
  txhormigon : string ="pl-3";
  txnivelMar : string ="text-prim pl-3";
  txpreCordillera : string ="pl-3";
  txCordillera : string ="pl-3";
  txOff : string ="pl-3";
  txOn : string ="text-prim pl-3";
  casas : string ="assets/images/CasasOFF.png";
  casasOff : string ="assets/images/CasasOFF.png";
  casasOn : string ="assets/images/CasasON.png";
  edificio : string ="assets/images/EdificioOFF.png";
  edificioOn : string ="assets/images/EdificioON.png";
  edificioOff : string ="assets/images/EdificioOFF.png";
  tabiqueria : string ="assets/images/TabiqueriaON.png";
  tabiqueriaOn : string ="assets/images/TabiqueriaON.png";
  tabiqueriaOFF : string ="assets/images/TabiqueriaOFF.png";
  ladrillo : string ="assets/images/LadrilloOFF.png";
  ladrilloOn : string ="assets/images/LadrilloON.png";
  ladrilloOFF : string ="assets/images/LadrilloOFF.png";
  hormigon : string ="assets/images/HormigonOFF.png";
  hormigonOn : string ="assets/images/HormigonON.png";
  hormigonOFF : string ="assets/images/HormigonOFF.png";
  nivelMar : string ="assets/images/NivelMarON.png";
  nivelMarOn : string ="assets/images/NivelMarON.png";
  nivelMarOFF : string ="assets/images/NivelMarOFF.png";
  precordillera : string ="assets/images/PreCordilleraOFF.png";
  precordilleraOn : string ="assets/images/PreCordilleraON.png";
  precordilleraOFF : string ="assets/images/PreCordilleraOFF.png";
  cordillera : string ="assets/images/CordilleraOFF.png";
  cordilleraOn : string ="assets/images/CordilleraON.png";
  cordilleraOFF : string ="assets/images/CordilleraOFF.png";

  distribuidora : string = "";
  espacios : number = 1;
  anio:number = -1;
  date = new Date();
  showCalculo : boolean = false;
  comuna : Comuna = {};
  seremia : Seremia = {};
  arrEspacios : Espacio[] = [];
  formulario : Formulario = {
    comuna:"",
    tipologia_vivienda:0,
    materialidad:0,
    anio_construccion:0,
    espacios:this.arrEspacios, 
    altitud : 0
  };
  requestCalculadora : RequestCalculadora = {action : "get_equipos", formulario : this.formulario}
  respuestaCalculadora : Respuesta = {espacios:[]};


  anioControl = new FormControl("", [Validators.min(0),])
  nombreEspacionControl = new FormControl("", [Validators.required,])
  espaciosControl = new FormControl("", 
    [
      Validators.min(1), 
      Validators.required
    ]);

  

  constructor(
    private router : Router,
    private dataService : DataService,
    private calculadoraService : CalculadoraService

  ) { }

  arrayEspacios(n: number): any[] {
    return Array(n);
  }

  ngOnInit() {
    
   this.dataService.getRegiones().subscribe(resp=>{
    resp.sort(function (a, b) {
      return parseInt(a.Posicion) - parseInt(b.Posicion);
    });

     this.regiones = resp;

     this.arrEspacios.push({
       nombre:"Habitación",
       superficie:10
     })
   });
  }

  changeRegion(regionid){
    //console.log("Change");
    this.showElec = false;
    this.showDist = false;
    this.showDistPage = false;
    this.showFinanciamiento = false;
    this.showCalculo = false;
    if(regionid>0){
      this.getSerermia(regionid);
      this.comunas = [];
      this.formulario.comuna = "";
      this.dataService.getComunas().subscribe(resp=>{
        var result = resp.filter(function(el){
          return el.RegionId == regionid && el.Beneficiada=="1"
        });
        this.comunas =  result;
      });
    }else{
      this.formulario.comuna = "";
      this.comunas = [];
      this.showEquipo = false;
      this.showPreguntas = false;
      this.beneficiada = true;
      this.compra = true;
    }
  }


  getSerermia(regionId){
    this.dataService.getSeremias().subscribe(resp=>{
      var result = resp.find(function(el){
        return el.RegionId == regionId
      });
      this.seremia =  result;
    })
  }

  changeComuna(comuna){
    
    //console.log(comuna)
    if(comuna!=""){
      
      var comunaEl = this.comunas.find(function(el){
        return el.Nombre == comuna;
      })
      this.comuna  = comunaEl;
      this.distribuidora = null;
      var id = this.comuna.Id.toString();
      //console.log(id);
      this.dataService.getDistribuidoras()
        .subscribe(resp=>{
          //console.log(resp);
          //console.log(id);
          var dists = resp.filter(function(el){
            return el.comunaId == id.toString();
          });
          //console.log(dists);
         this.distribuidoras = dists;
         
          if(dists){
            this.distribuidora = "";
          }
         
        });
      if(comunaEl.Beneficiada=="0"){
        this.beneficiada = false;
        this.showElec = false;
      }else{
        this.beneficiada = true;
        this.showElec = true;
      }
      if(this.checkAltura()){
        this.showAltitud = true;
        
      }else{
        this.showAltitud = false;
        this.formulario.altitud = 0;
      }
      
      
    }else{
      this.showElec = false;
      this.showDist = false;
      this.showDistPage = false;
      this.showFinanciamiento = false;
      this.showCalculo = false;
    }

  }

  elecSi(){
    this.showDist = false;
    this.showFinanciamiento = true;
  }

  electNo(){
    this.showDist = true;
    this.showFinanciamiento = false;
    
  }

  changeDistribuidora(){
    var dst = this.selDistribuidora;
    if(this.selDistribuidora!="sel"){
      var dist =  this.distribuidoras.find(function(el){
        return el.distribuidora == dst;
      })
      this.distribuidoraObj = dist;
      console.log( this.distribuidoraObj);
      this.showDistPage = true;
    }else{
      this.showDistPage = false;
    }
  }

  changeFinanciamiento(){
    this.showEmpaquetadas = this.selFinanciamiento == 5 ? true: false;

    if(this.selFinanciamiento==2 || this.selFinanciamiento==3 || this.selFinanciamiento==4 ){
      this.showProgramas = true;
    }else{
      this.showProgramas = false;
    }

    this.showPreguntas = this.selFinanciamiento == 1 ? true : false;
  }

  checkAltura(){
    var ids = ["97","106","92","98","84","129","132","134"];
    console.log(this.comuna.Id);
    console.log(ids.includes(this.comuna.Id ));
    return ids.includes(this.comuna.Id );
  }

  compraSi(){
    this.compra = true;
    this.showPreguntas = true;
  }
  compraNo(){
    this.showPreguntas = false;
    this.compra = false;
    var id = this.comuna.Id.toString();
    //console.log(id);
    this.dataService.getDistribuidoras()
      .subscribe(resp=>{
        var dist = resp.find(el=>{
          return el.comunaId == id.toString();
        });
        //console.log(dist);
        if(dist){
          this.distribuidora = dist.distribuidora;
        }
       
      });
  }
  submitForm(){
    console.log("submit");
    this.router.navigate(['/lista']);
  }

  calculadora(){
    
    this.showCalculo = true;
    this.requestCalculadora.formulario.espacios = this.arrEspacios;
    this.calculadoraService.getData(this.requestCalculadora).subscribe(resp=>{
      
      this.respuestaCalculadora = resp.respuesta;
      
    });
    
  }

  validForm(){
    if(this.anioControl.valid &&  this.nombreEspacionControl.valid){
      return true;
    }else{
      return false;
    }
  }
  setBtu(arr : number[]){
    var btu = "";
    for(var i = 0 ; i<arr.length ; i++){
      if(arr[i]==1){
        switch (i){
          case 0 : btu="9.000";
          break;
          case 1 : btu="12.000";
          break;
          case 2 : btu="18.000";
          break;
          case 3 : btu="22.000";
          break;
          case 3 : btu="24.000";
          break;
        }
      }
    }
    return btu;
  }

  roundPot(pot: number){
    return Math.round(pot)
  }


  changeEspacios(){
    this.arrEspacios = [];
    var arrNombre = ["Uno","Dos","Tres","Cuatro"];

    for(var i=0;i<this.espacios; i++){
      this.arrEspacios.push({
        nombre:"Habitación",
        superficie:10  
      })
    }
    
      //this.arrEspacios[0].nombre = "Uno";
    
    console.log(this.arrEspacios)
  }

  mouseOutCasa(){
   
    if(this.formulario.tipologia_vivienda==0){
      this.casas = this.casasOff;
      this.txcasas = this.txOff;
      this.edificio = this.edificioOff
      this.txedificio = this.txOff;
      
    }else{
      this.casa = this.casaOff;
      this.txcasa = this.txOff;
    }
  }

  mouseOutCasas(){
   
    if(this.formulario.tipologia_vivienda==1){
      this.casa = this.casaOff;
      this.txcasa = this.txOff;
      this.edificio = this.edificioOff;
      this.txedificio = this.txOff;
    }else{
      this.casas = this.casasOff;
      this.txcasas = this.txOff;
    }
  }
  mouseOutEdificio(){
   
    if(this.formulario.tipologia_vivienda==2){
      this.casa = this.casaOff;
      this.txcasa = this.txOff;
      this.casas = this.casasOff
      this.txcasas = this.txOff;
    }else{
      this.edificio = this.edificioOff;
      this.txedificio = this.txOff;
    }
  }
  clickCasa(){
    this.casas = this.casasOff;
    this.txcasas = this.txOff;
    this.edificio = this.edificioOff
    this.txedificio = this.txOff;
  }
  clickCasas(){
    this.casa = this.casaOff;
    this.txcasa = this.txOff;
    this.edificio = this.edificioOff
    this.txedificio = this.txOff;
  }

  clickEdificio(){
    this.casa = this.casaOff;
    this.txcasa = this.txOff;
    this.casas = this.casasOff
    this.txcasas = this.txOff;
  }
  mouseOutTabiqueria(){
    if(this.formulario.materialidad==0){
      this.ladrillo = this.ladrilloOFF;
      this.hormigon = this.hormigonOFF
      this.txladrillo = this.txOff;
      this.txhormigon = this.txOff;
    }else{
      this.tabiqueria = this.tabiqueriaOFF;
      this.txtabiqueria = this.txOff;
    }
  }

  clickTabiqueria(){
    this.ladrillo = this.ladrilloOFF;
    this.hormigon = this.hormigonOFF;
    this.txladrillo = this.txOff;
    this.txhormigon = this.txOff;
    this.txtabiqueria = this.txOn;
  }
  mouseOutLadrillo(){
    if(this.formulario.materialidad==1){
      this.tabiqueria = this.tabiqueriaOFF;
      this.hormigon = this.hormigonOFF;
      this.txtabiqueria = this.txOff;
      this.txhormigon = this.txOff;
      
    }else{
      this.ladrillo = this.ladrilloOFF;
      this.txladrillo = this.txOff;
    }
  }

  clickLadrillo(){
    this.tabiqueria = this.tabiqueriaOFF;
    this.hormigon = this.hormigonOFF;
    this.txtabiqueria = this.txOff;
    this.txhormigon = this.txOff;
    this.txladrillo = this.txOn;
  }
  mouseOutHormigon(){
    if(this.formulario.materialidad==2){
      this.tabiqueria = this.tabiqueriaOFF;
      this.ladrillo = this.ladrilloOFF;
    }else{
      this.hormigon = this.hormigonOFF;
      this.txhormigon = this.txOff;
    }
  }

  clickHormigon(){
    this.tabiqueria = this.tabiqueriaOFF;
    this.ladrillo = this.ladrilloOFF;
    this.txtabiqueria = this.txOff;
    this.ladrillo = this.ladrilloOFF;
    this.txhormigon = this.txOn;
  }
  mouseOutNivelMar(){
    if(this.formulario.altitud==0){
      this.precordillera = this.precordilleraOFF;
      this.cordillera = this.cordilleraOFF;
      this.txpreCordillera = this.txOff;
      this.txCordillera = this.txOff;
    }else{
      this.nivelMar = this.nivelMarOFF;
      this.txnivelMar = this.txOff;
    }
  }

  clickNivelMar(){
    this.precordillera = this.precordilleraOFF;
    this.cordillera = this.cordilleraOFF;
    this.txpreCordillera = this.txOff;
    this.txCordillera = this.txOff;
    this.txnivelMar = this.txOn;
  }

  mouseOutPreCordillera(){
    if(this.formulario.altitud==1){
      this.nivelMar = this.nivelMarOFF;
      this.cordillera = this.cordilleraOFF;
      this.txnivelMar = this.txOff;
      this.txCordillera = this.txOff;
    }else{
      this.precordillera = this.precordilleraOFF;
      this.txpreCordillera = this.txOff;
    }
  }

  clickPrecordillera(){
    this.nivelMar = this.nivelMarOFF;
    this.cordillera = this.cordilleraOFF;
    this.txnivelMar = this.txOff;
    this.txCordillera = this.txOff;
    this.txpreCordillera = this.txOn;
  }

  mouseOutCordillera(){
    if(this.formulario.altitud==2){
      this.nivelMar = this.nivelMarOFF;
      this.precordillera = this.precordilleraOFF;
      this.txnivelMar = this.txOff;
      this.txpreCordillera = this.txOff;
    }else{
      this.cordillera = this.cordilleraOFF;
      this.txCordillera = this.txOff;
    }
  }

  clickCordillera(){
    this.nivelMar = this.nivelMarOFF;
    this.precordillera = this.precordilleraOFF;
    this.txnivelMar = this.txOff;
    this.txpreCordillera = this.txOff;
    this.txCordillera = this.txOn;
  }

  formatNumber(number:number,fractionSize:number):string{
    var aux,n;
    if(number){
      if(number>=100000){
        n = number/10000;
        aux = Math.round(n)*10000;
      }
      if(number>=10000){ //12537 / 1000
        n = number/1000;
        aux = Math.round(n)*1000;
      }
      if(number>=1000 && number <10000){ //1587 / 1000
        n = number/100;
        aux = Math.round(n)*100;
      }
      if(number>=100 && number <1000){ //873 / 1000
        n = number/10;
        aux = Math.round(n)*10;
      }
      if(number<100){
        n = fractionSize*10;
        aux = n>0?Math.round(number*n)/n:Math.round(number);
      }
      //console.log(aux.toLocaleString('es-CL', {maximumFractionDigits: fractionSize}));
      //console.log(String(aux).replace(".",","));
      var semifinal = String(aux).replace(".",",");
      var th = Math.floor((semifinal.length-1)/3); // 6 --> 1 // 4 --> 1
      var final = "";
      for (let i = semifinal.length - 3; i > 0 ; i-=3) { //100000 // 1000000
        final = "." + semifinal.substr(i,3) + final;
      }
      final = semifinal.substr(0,semifinal.length-Math.floor(Math.log(aux)/Math.log(1000))*3) + final;
      return final;
    }else{
      return "";
    }
  }

}
